
import products from '~/services/products'
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    selectedItems: {
      default: () => [],
    },
  },
  data() {
    return {
      products: [],
    }
  },
  mounted() {
    this.products = products.getByCategoryId(this.item.id)
  },
}
